import React from "react";
import { COMPONENTS } from "../../constants/chatConstants";

export default function DialogSVG({ component }) {
    return (
        <svg id="chat" width="25" viewBox="0 0 33.238 31.033">
            <path
                d="M32.151,41.506a11.238,11.238,0,0,0,1.087-4.855A11.4,11.4,0,0,0,22.374,25.3,11.4,11.4,0,0,0,0,28.341,11.238,11.238,0,0,0,1.088,33.2L.02,38.537a.974.974,0,0,0,1.144,1.146L6.57,38.614a11.2,11.2,0,0,0,4.3,1.073,11.379,11.379,0,0,0,15.8,7.236c5.921,1.171,5.459,1.087,5.6,1.087a.974.974,0,0,0,.955-1.165Zm-25-4.778a.974.974,0,0,0-.632-.088l-4.3.85.847-4.236a.973.973,0,0,0-.088-.634,9.312,9.312,0,0,1-1.026-4.279,9.452,9.452,0,0,1,18.415-2.959A11.374,11.374,0,0,0,10.5,37.709a9.273,9.273,0,0,1-3.355-.981Zm23.029,4.835.847,4.236-4.3-.85a.974.974,0,0,0-.632.088,9.312,9.312,0,0,1-4.279,1.026,9.413,9.413,0,1,1,9.478-9.413,9.312,9.312,0,0,1-1.026,4.279A.973.973,0,0,0,30.176,41.564Z"
                transform="translate(0 -16.981)"
                fill={component === COMPONENTS.CHAT ? "#000000" : "#959baa"}
            />
        </svg>
    );
}
